// extracted by mini-css-extract-plugin
export default {"container":"search_container__C7ZHH","close_page":"search_close_page__-8+ku","title":"search_title__cf0fG","form":"search_form__NhYN-"};